<template>
  <div class="tw-flex tw-h-24 tw-items-center tw-justify-center">
    <i>
      The block driver does not have any parameters.
    </i>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
